import React, { useState, useEffect } from "react";
import { geocodeByAddress, getLatLng } from "react-places-autocomplete";
import { toast } from "react-toastify";
import { useParams, useHistory } from "react-router-dom";
import { useFormik } from "formik";

import { useStore } from "@store/store";
import Loader from "@components/loader";
import DeletePopup from "@components/deletePopup";
import validationSchema from "@utils/validationSchemas";
import { routes } from "@utils/constant";
import {
  FETCH_CUSTOMERS,
  FETCH_CUSTOMERS_SUCCESS,
  FETCH_CUSTOMERS_FAILURE,
  GET_CITIES,
  GET_CITIES_SUCCESS,
  GET_CITIES_FAILURE,
  FETCH_DRIVERS,
  FETCH_DRIVERS_SUCCESS,
  FETCH_DRIVERS_FAILURE,
  EDIT_INTERSTATE_JOB,
  EDIT_INTERSTATE_JOB_SUCCESS,
  EDIT_INTERSTATE_JOB_FAILURE,
  REVIEW_JOBS,
  REVIEW_JOBS_SUCCESS,
  REVIEW_JOBS_FAILURE,
  DELETE_JOB,
  DELETE_JOB_SUCCESS,
  DELETE_JOB_FAILURE,
  FETCH_PICK_UP_CTOS,
  FETCH_PICK_UP_CTOS_SUCCESS,
  FETCH_PICK_UP_CTOS_FAILURE,
  FETCH_DROP_OFF_CTOS,
  FETCH_DROP_OFF_CTOS_SUCCESS,
  FETCH_DROP_OFF_CTOS_FAILURE
} from "@utils/actionTypes";
import Popup from "@views/job-listing/create-interstate-job/popup";
import API from "@services/axios";
import EditView from "./form";
import { EditBlockStyle } from "./style";
import RollbackPopup from "@components/rollbackPopup";
import {
  ROLLBACK_JOB,
  ROLLBACK_JOB_FAILURE,
  ROLLBACK_JOB_SUCCESS
} from "@utils/actionTypes";

function EditBlock(props) {
  const classes = EditBlockStyle();
  const [open, setOpen] = useState(false);
  const [isClick, setClick] = useState(false);
  const [error, setError] = useState("");
  const [openDeletePopup, setDeletePopup] = useState(false);
  const [openRollbackPopup, setRollbackPopup] = useState(false);
  const [state, dispatch] = useStore();
  const { id } = useParams();
  const history = useHistory();
  const handleClickOpen = () => {
    setOpen(true);
    formik.handleReset();
  };
  const handleClose = () => {
    setOpen(false);
    formik.handleReset();
    setError("");
  };

  const handleDelete = () => {
    setDeletePopup(false);
    dispatch({ type: DELETE_JOB });
    API.delete(`/jobs/${id}`)
      .then(() => {
        dispatch({
          type: DELETE_JOB_SUCCESS,
        });
        if (props.routeUrl) {
          history.push(props.routeUrl);
        } else {
          history.push(routes.jobListing);
        }
        
        toast.success("Job Deleted Successfully");
      })
      .catch((error) => {
        dispatch({ type: DELETE_JOB_FAILURE });
        toast.error(error?.response?.data?.message);
      });
  };

  const handleRollbackMerge = () => {
    setRollbackPopup(false);
    dispatch({ type: ROLLBACK_JOB });
    API.get(`/jobs/${id}/rollbackMergeJob`)
      .then(() => {
        dispatch({
          type: ROLLBACK_JOB_SUCCESS,
        });
        history.push(`${routes.interstateJobDetail}/${props.jobsData?.id}`);
        toast.success("Merge rolled back successfully");
        props.getJobs();
      })
      .catch((error) => {
        dispatch({ type: ROLLBACK_JOB_FAILURE });
        toast.error(error?.response?.data?.message);
      });
  };

  const handleDeletePopup = () => {
    setDeletePopup(true);
  };

  const handleRollbackPopup = () => {
    setRollbackPopup(true);
  };

  // API calling to update interstate job
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      customerId: props.jobsData?.customers ? props.jobsData?.customers.id : "",
      requesterName: props.jobsData?.requesterName ? props.jobsData?.requesterName : "",
      driverId: props.jobsData?.drivers ? props.jobsData?.drivers.id : "",
      isPreloadChargeApplied: props.jobsData?.isPreloadChargeApplied ?? false,
      pickUpCityId: props.jobsData?.cities ? props.jobsData?.cities.id : "",
      pickUpLocationType: props.jobsData?.pickUpLocationType ? props.jobsData?.pickUpLocationType : "",
      pickUpLocation: props.jobsData?.pickUpLocation ? props.jobsData?.pickUpLocation : "",
      pickUpLatitude: props.jobsData?.pickUpLatitude ? props.jobsData?.pickUpLatitude : "",
      pickUpLongitude: props.jobsData?.pickUpLongitude ? props.jobsData?.pickUpLongitude : "",
      pickUpCtoId: props.jobsData?.ctos ? props.jobsData?.ctos.id : "",
      dropOffCityId: props.jobsData?.dropOffCity ? props.jobsData?.dropOffCity.id : "",
      dropOffLocationType: props.jobsData?.dropOffLocationType ? props.jobsData?.dropOffLocationType : "",
      dropOffLocation: props.jobsData?.dropOffLocation ? props.jobsData?.dropOffLocation : "",
      dropOffLatitude: props.jobsData?.dropOffLatitude ? props.jobsData?.dropOffLatitude : "",
      dropOffLongitude: props.jobsData?.dropOffLongitude ? props.jobsData?.dropOffLongitude : "",
      dropOffCtoId: props.jobsData?.dropOffCto ? props.jobsData?.dropOffCto.id : "",
      description: props.jobsData?.description ? props.jobsData?.description : "",
      quantity: props.jobsData?.quantity? props.jobsData?.quantity : 0,
      weight: props.jobsData?.weight ? props.jobsData?.weight : 0,
    },
    validationSchema: validationSchema.editInterstateJobValidationSchema,
    onSubmit: (value) => {
      let data = {
        customerId: value.customerId,
        isPreloadChargeApplied: value.isPreloadChargeApplied,
        pickUpCityId: value.pickUpCityId,
        pickUpLocationType: value.pickUpLocationType,
        pickUpLatitude: value.pickUpLatitude,
        pickUpLongitude: value.pickUpLongitude,
        dropOffCityId: value.dropOffCityId,
        dropOffLocationType: value.dropOffLocationType,
        dropOffLatitude: value.dropOffLatitude,
        dropOffLongitude: value.dropOffLongitude,
      };
      data = {
        ...data,
        ...(value.pickUpLocationType === "2" && !!value.pickUpCtoId ? { pickUpCtoId: value.pickUpCtoId } : { pickUpCtoId: null }),
        ...(!!value.pickUpLocation ? { pickUpLocation: value.pickUpLocation } : {}),
        ...(value.dropOffLocationType === "2" && !!value.dropOffCtoId ? { dropOffCtoId: value.dropOffCtoId } : { dropOffCtoId: null }),
        ...(!!value.dropOffLocation ? { dropOffLocation: value.dropOffLocation } : {}),
        ...(!!value.requesterName ? { requesterName: value.requesterName } : {}),
        ...(!!value.driverId ? { driverId: value.driverId } : {}),
        ...(!!value.description ? { description: value.description } : {}),
      };

      dispatch({ type: EDIT_INTERSTATE_JOB });
      API.put(`interstateJobs/${id}`, data)
        .then((response) => {
          dispatch({
            type: EDIT_INTERSTATE_JOB_SUCCESS,
            payload: response.data.data,
          });
          handleClose();
          props.getInterstateJobs();
          toast.success("Job Updated Successfully");
        })
        .catch((err) => {
          dispatch({ type: EDIT_INTERSTATE_JOB_FAILURE, payload: err });
          setError(err?.response?.data?.message);
        });
    },
  });

  useEffect(() => {
    if (state?.common?.countriesData === null) {
      dispatch({ type: GET_CITIES });
      API.get("master/cities")
        .then((response) => {
          dispatch({
            type: GET_CITIES_SUCCESS,
            payload: response.data.data,
          });
        })
        .catch((error) => {
          dispatch({ type: GET_CITIES_FAILURE, payload: error });
        });
    }

    dispatch({ type: FETCH_DRIVERS });
    API.get("drivers", {
      params: {
        order: "ASC",
        orderBy: "driverName",
        filter: { active: true },
        isInterstate: true
      }
    })
      .then((response) => {
        dispatch({
          type: FETCH_DRIVERS_SUCCESS,
          payload: response.data.data,
        });
      })
      .catch((error) => {
        dispatch({ type: FETCH_DRIVERS_FAILURE, payload: error });
      });

    dispatch({ type: FETCH_CUSTOMERS });
    API.get("customers", {
      params: {
        orderBy: "name",
        order: "asc",
        filter: { parent: 0, status: true },
      },
    })
      .then((response) => {
        dispatch({
          type: FETCH_CUSTOMERS_SUCCESS,
          payload: response.data.data,
        });
      })
      .catch((error) => {
        dispatch({ type: FETCH_CUSTOMERS_FAILURE, payload: error });
      });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (open && formik.values.pickUpCityId && formik.values.pickUpLocationType === '2') {
      const params = {
        cityId: formik.values.pickUpCityId,
      };
      dispatch({type: FETCH_PICK_UP_CTOS});
      API.get("master/ctos", {params})
        .then((response) => {
          dispatch({
            type: FETCH_PICK_UP_CTOS_SUCCESS,
            payload: response.data.data,
          });
        })
        .catch((error) => {
          dispatch({type: FETCH_PICK_UP_CTOS_FAILURE, payload: error});
        });
    }
  }, [open, formik.values.pickUpCityId, formik.values.pickUpLocationType]);

  useEffect(() => {
    if (open && formik.values.dropOffCityId && formik.values.dropOffLocationType === '2') {
      const params = {
        cityId: formik.values.dropOffCityId,
      };
      dispatch({type: FETCH_DROP_OFF_CTOS});
      API.get("master/ctos", {params})
        .then((response) => {
          dispatch({
            type: FETCH_DROP_OFF_CTOS_SUCCESS,
            payload: response.data.data,
          });
        })
        .catch((error) => {
          dispatch({type: FETCH_DROP_OFF_CTOS_FAILURE, payload: error});
        });
    }
  }, [open, formik.values.dropOffCityId, formik.values.dropOffLocationType]);

  // To handle location fields
  const handleChange = (address, type) => {
    type === "pickUpLocation"
      ? formik.setFieldValue("pickUpLocation", address)
      : formik.setFieldValue("dropOffLocation", address);
  };

  // To handle lat/long and address while selecting address from google place API.
  const handleSelect = (address, type) => {
    type === "pickUpLocation"
      ? formik.setFieldValue("pickUpLocation", address)
      : formik.setFieldValue("dropOffLocation", address);
    geocodeByAddress(address)
      .then((results) => getLatLng(results[0]))
      .then((latLng) => {
        return type === "pickUpLocation"
          ? (formik.setFieldValue("pickUpLatitude", latLng.lat),
            formik.setFieldValue("pickUpLongitude", latLng.lng))
          : (formik.setFieldValue("dropOffLatitude", latLng.lat),
            formik.setFieldValue("dropOffLongitude", latLng.lng));
      })
      .catch((error) => console.error("Error", error));
  };

  const handleReview = () => {
    dispatch({ type: REVIEW_JOBS });
    API.put("jobs/reviewCompleted", { jobIds: [id] })
      .then((response) => {
        dispatch({
          type: REVIEW_JOBS_SUCCESS,
          payload: response.data.data,
        });
        setClick(true);
      })
      .catch((error) => {
        dispatch({ type: REVIEW_JOBS_FAILURE, payload: error });
      });
  };
  return (
    <div className={classes.EditBlockWrapper}>
      <Loader
        loading={
          props.loadingJobs ||
          state.job?.loadingJobConsignment ||
          state.job?.reviewingJobs ||
          state.job?.deletingJob ||
          state.job?.editingInterstateJob
        }
      />
      <EditView
        handleDeletePopup={handleDeletePopup}
        handleRollbackPopup={handleRollbackPopup}
        handleClickOpen={handleClickOpen}
        handleReview={handleReview}
        isClick={isClick}
        jobsData={props.jobsData}
        getJobs={props.getJobs}
      />
      <DeletePopup
        open={openDeletePopup}
        handleClose={() => setDeletePopup(false)}
        handleDelete={() => handleDelete(id)}
        deleteUser={`Job Id ${id}`}
      />
      <RollbackPopup
        open={openRollbackPopup}
        handleClose={() => setRollbackPopup(false)}
        handleRollback={() => handleRollbackMerge(id)}
      />
      <Popup
        open={open}
        handleClose={handleClose}
        formik={formik}
        isEdit={true}
        handleChange={handleChange}
        handleSelect={handleSelect}
        error={error}
      />
    </div>
  );
}
export default EditBlock;
